module.exports = __webpack_public_path__ + "img/list-empty.a5f43dd8.png";